import { 
	GET_PROJECT_QA_ACTION_ITEMS_STATUSES, 
	GET_PROJECT_QA_ACTION_ITEMS_STATUS,
	CREATE_PROJECT_QA_ACTION_ITEMS_STATUS,
	UPDATE_PROJECT_QA_ACTION_ITEMS_STATUS,
	DESTROY_PROJECT_QA_ACTION_ITEMS_STATUS,
} from "./actions"

export function ProjectQaActionItemsStatusesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_QA_ACTION_ITEMS_STATUSES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_QA_ACTION_ITEMS_STATUS}_FULFILLED`:
		case `${CREATE_PROJECT_QA_ACTION_ITEMS_STATUS}_FULFILLED`:
		case `${UPDATE_PROJECT_QA_ACTION_ITEMS_STATUS}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_QA_ACTION_ITEMS_STATUS}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectQaActionItemsStatusesReducer } from "modules/project/qa/action_items/statuses/reducer"

// project_qa_action_items_statuses:ProjectQaActionItemsStatusesReducer,
